import { MaintenanceForwardingCheckinEntryKlass, MaintenanceForwardingCheckinEntryMap } from "./forwardings/checkinEntries/checkinEntry.type";
import { MaintenanceForwardingDirectiveEntryMap } from "./forwardings/directiveEntries/directiveEntry.type";
import { MaintenanceForwardingEstablishmentChoiceEntryKlass, MaintenanceForwardingEstablishmentChoiceEntryMap } from "./forwardings/establishmentChoiceEntries/establishmentChoiceEntry.type";
import { MaintenanceFiscalAssessmentEntryData } from "./forwardings/fiscalAssessmentEntry/fiscalAssessmentEntry.type";
import { MaintenanceForwardingsDirectiveEntryKlass } from "./maintenanceForwardingsDirectiveEntryKlasses.type";

export enum MaintenanceForwardingDirectiveEntryStatus {
  Pending = 'pending',
  AwaitingManualStart = 'awaiting_manual_start',
  InProgress = 'in_progress',
  AwaitingClientReview = 'awaiting_client_review',
  Completed = 'completed',
}

export enum MaintenanceForwardingStatus {
  Canceled = 'canceled',
  ComplementTextField = 'completed',
  OnGoingEstablishmentChoice = 'ongoing_establishment_choice',
  OnGoingCheckin = 'ongoing_checkin',
  OnGoingDirective = 'ongoing_directive',
  OnGoingFinancialReview = 'ongoing_financial_review',
  OnGoingFiscalAssessment = 'ongoing_fiscal_assessment',
}

export type MaintenanceForwardingData<
  DirectiveEntry extends MaintenanceForwardingDirectiveEntryMap[MaintenanceForwardingsDirectiveEntryKlass] = never,
  EstablishmentChoiceEntry extends MaintenanceForwardingEstablishmentChoiceEntryMap[MaintenanceForwardingEstablishmentChoiceEntryKlass] = never,
> = {
  canceled_at: string | null;
  checkin_entry: MaintenanceForwardingCheckinEntryMap[MaintenanceForwardingCheckinEntryKlass.TransportAutoEntry];
  checkin_entry_type: MaintenanceForwardingCheckinEntryKlass;
  checkout_entry: null;
  completed_at: string | null;
  created_at: string;
  directive_entry: DirectiveEntry;
  establishment_choice_entry: EstablishmentChoiceEntry;
  establishment_choice_entry_type: MaintenanceForwardingEstablishmentChoiceEntryKlass;
  fiscal_assessment_entry: MaintenanceFiscalAssessmentEntryData;
  fiscal_assessment_entry_type: string;
  id: string;
  status: MaintenanceForwardingStatus;
  updated_at: string;
  workflow: {
    id: string;
  };
}

export type MaintenanceForwardingResponse = {
  data: {
    data: MaintenanceForwardingData;
  }
}
